import { render, staticRenderFns } from "./MessagesViewDownload.vue?vue&type=template&id=5033ddf2&scoped=true"
import script from "./MessagesViewDownload.vue?vue&type=script&lang=js"
export * from "./MessagesViewDownload.vue?vue&type=script&lang=js"
import style0 from "./MessagesViewDownload.vue?vue&type=style&index=0&id=5033ddf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033ddf2",
  null
  
)

export default component.exports